module.exports = __webpack_public_path__ + "img/zmcafe-beer.00850ffb.png";